// Tiny localStorage-backed boolean flag helper. Used for UI toggles (debug
// HUD visibility, etc.) that should survive reloads. Returns the supplied
// default when nothing has been written yet, and treats malformed stored
// values as the default so a stale entry can't disable a feature.

export function readPersistentFlag(key: string, defaultValue: boolean): boolean {
  const raw = window.localStorage.getItem(key);
  if (raw === null) return defaultValue;
  if (raw === '1' || raw === 'true') return true;
  if (raw === '0' || raw === 'false') return false;
  return defaultValue;
}

export function writePersistentFlag(key: string, value: boolean): void {
  window.localStorage.setItem(key, value ? '1' : '0');
}
